module.exports = __webpack_public_path__ + "static/media/55_000076.66340019.jpg";